import { Checkbox, Form } from "@/atoms"
import classNames from "classnames"

import styles from "./CheckboxSettingsGroup.module.scss"

import type { CheckboxSettingsGroupProps } from "."

export const CheckboxSettingsGroup = (props: CheckboxSettingsGroupProps) => {
  const { items } = props

  return (
    <div>
      {items.map((item) => (
        <div key={item.key} className={styles.row}>
          <div className={styles.title}>{item.label}</div>
          <Form.Item name={item.key} noStyle>
            <Checkbox.Group>
              <div
                className={classNames(
                  styles.checkboxGroup,
                  item.gap !== undefined && styles[`gap${item.gap}`]
                )}
              >
                {item.children}
              </div>
            </Checkbox.Group>
          </Form.Item>
        </div>
      ))}
    </div>
  )
}
